
export const LocationAuthorizationStatus = {
  GRANTED: "granted",
  DENIED: "denied",
  NOT_DETERMINED: "notDetermined"
}
